import React from 'react';
import { useAdminShortcuts } from '../hooks/useAdminShortcuts';
import { useAdminSettings } from '../context/AdminSettingsContext';

interface AdminWrapperProps {
  children: React.ReactNode;
}

export function AdminWrapper({ children }: AdminWrapperProps) {
  // Initialize admin keyboard shortcuts
  useAdminShortcuts();
  
  // Get admin settings
  const { settings, isAdmin } = useAdminSettings();
  
  return (
    <>
      {children}
    </>
  );
}